import { IconButton, Select } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, CategoryType, ICategoryList } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import FloatingInputLabel from "../../../components/editable/EditableField/components/FloatingInputLabel";
import { ProgressView } from "../../../components/notifications/progress/ProgressView";
import flex from "../../../styles/flex";
import { FiList, FiPlus } from "react-icons/fi";
import TextInputField from "../../../components/editable/EditableField/fields/TextInputField";
import { useTranslation } from "react-i18next";


const CategorySelector: React.FunctionComponent<{
    label: string,
    value?: string;
    type: CategoryType;
    onChange: (value: string) => void;
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();
    const [params] = useState<ICategoryList>({
        type: props.type,
    });

    const catFetch = api.hooks.category.list();

    useEffect(() => {
        catFetch.send(session.current.context, params);
    }, [params]);

    const [manual, setManual] = useState(false);

    return (
        <ProgressView status={catFetch.status}>


            <div style={flex.flexRows}>

                <div style={flex.flexAuto}>
                    <div style={{ marginTop: 3 }}>
                        {manual == true && (
                            <TextInputField label={t("reports.createNew")} value={props.value} onChange={(value) => {
                                props.onChange(value);
                            }} />
                        )}
                        {manual == false && (
                            <FloatingInputLabel label={props.label}>
                                <Select

                                    native
                                    style={{ width: "100%", minWidth: 218, maxWidth: 218, borderRadius: 5, padding: 5 }}

                                    value={props.value}
                                    onChange={(e) => {
                                        props.onChange(e.target.value as string);
                                    }}
                                >
                                    <option value={""} title={t("reports.optionSelect")}>- {t("reports.select")} -</option>
                                    {catFetch.data != null && catFetch.data.map((item, i) => {
                                        return <option key={i} value={item.categoryName} title={item.categoryName}>{item.categoryName}</option>;
                                    })}
                                </Select>
                            </FloatingInputLabel>
                        )}
                    </div>
                </div>

                {manual == false && (
                    <div style={flex.flexAuto}>
                        <IconButton
                            onClick={() => {
                                setManual(true);
                                props.onChange("");
                            }}>
                            <FiPlus></FiPlus>
                        </IconButton>
                    </div>
                )}
                {manual == true && (
                    <div style={flex.flexAuto}>
                        <IconButton
                            onClick={() => {
                                setManual(false);
                            }}>
                            <FiList></FiList>
                        </IconButton>
                    </div>
                )}
            </div>


        </ProgressView>
    );
}
CategorySelector.propTypes = {
    label: propTypes.string.isRequired,
    value: propTypes.string,
    onChange: propTypes.func.isRequired,
    type: propTypes.any.isRequired
}

export default CategorySelector;